// import { Injectable } from '@angular/core';
// import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';

// @Injectable({ providedIn: 'root' })
// export class AuthGuard implements CanActivate {

//   constructor(private router: Router) {}

//   canActivate(route: ActivatedRouteSnapshot): boolean {
//     const token = localStorage.getItem('authToken');
//     const role  = localStorage.getItem('role');

//     if (!token || !role) {
//       this.router.navigate(['/login']);
//       return false;
//     }

//     const expectedRole = route.data?.['role'] as string;

//     if (expectedRole && role !== expectedRole) {
//       // Logged in but wrong role — send to their own dashboard
//       const dashboardMap: Record<string, string> = {
//         admin:      '/admin/dashboard',
//         instructor: '/instructor/dashboard',
//         student:    '/student/dashboard'
//       };
//       this.router.navigate([dashboardMap[role] || '/login']);
//       return false;
//     }

//     return true;
//   }
// }

// src/app/guards/auth.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { InactivityService } from '../services/inactivity.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private inactivity: InactivityService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const token = localStorage.getItem('authToken');
    const role  = localStorage.getItem('role');

    if (!token || !role) {
      this.inactivity.stop();
      this.router.navigate(['/login']);
      return false;
    }

    const expectedRole = route.data?.['role'] as string | undefined;
    if (expectedRole && role !== expectedRole) {
      // Wrong role — redirect to their actual dashboard, not to login
      const dashboardMap: Record<string, string> = {
        admin:      '/admin/dashboard',
        instructor: '/instructor/dashboard',
        student:    '/student/dashboard',
      };
      this.router.navigate([dashboardMap[role] || '/login']);
      return false;
    }

    // Valid authenticated navigation — ensure timer is running
    this.inactivity.start();
    return true;
  }
}